import { render, staticRenderFns } from "./SiteInfoRenewal.vue?vue&type=template&id=c4e2fe66&"
import script from "./SiteInfoRenewal.vue?vue&type=script&lang=ts&"
export * from "./SiteInfoRenewal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports